/* eslint-disable no-undef */
import React, {useContext, useEffect, useState, useCallback, useMemo} from "react";
import {useNavigate} from "react-router-dom";

//put this in export files - kb
import "./AdminPage.scss";
import {Context} from "../../../context/dataStore";
import {Context_role} from "../../../context/rolesStore";
import {AdminTable, Pagination, BandLayout, AnimatedEllipsis} from "../../../components";
import {ADMIN_ROLE, EM_ROLE, BCFP_ROLES_ARR} from "../../../constants/global";
import { ADMIN_LANDING_REMINDER, BFCP_LIVE } from "../../../constants/reminder";

export default function MultipleOrganizations() {
  let navigate = useNavigate();
  const [dataSurvey, setDataSurvey] = useState([]);
  const [loading, setLoading] = useState(false);
  const [is_BCFP_LIVE, set_BCFP_LIVE] = useState("");
  const {dispatch, state: {reminderData, orgData}} = useContext(Context);
  const {state: {newroles}} = useContext(Context_role);

  // ---COMPONENT DID MOUNT LIFE CYCLE
  useEffect(()=>{
    const applicationDataLayer = {page:{pageCode: "adminpage"}};
    if(typeof kiwi !== "undefined") kiwi.mergeDdl(applicationDataLayer);
    if(typeof _satellite !== "undefined") _satellite.track("cbTrack.viewInDom");
  },[]);

  useEffect(() => {
     setDataSurvey([...orgData]);
    if(orgData && orgData.length > 0) {
      setLoading(true);
    }
    //clear context values
    dispatch({type: "SELECT_ALL_COLUMNS", payload: [null, null, null, null, null, null, null, null, null]});
  }, [orgData]);
  useEffect(() => reminderData?.forEach(el => {
    if(el.code===BFCP_LIVE) {
      set_BCFP_LIVE(`${el.value}`);
    }
  }), [reminderData]);
  /**
   * this is used to update the pagination - the table and the pagination are different components
   * they need to be integrated.
   */
  const updatePaginationData = useCallback(data => {
    setDataSurvey([...data]);
  }, [setDataSurvey]);

  //pagenation related states
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(50);
  const lastPage = Math.ceil(dataSurvey?.length / recordPerPage);
  const displaySurvey = useMemo(() => dataSurvey?.slice((currentPage - 1) * recordPerPage, currentPage * recordPerPage),[dataSurvey, currentPage, recordPerPage]);

  // this is more pagination stuff
  const handleOnChange = useCallback(el => {
    let pagenum="page-";
    switch (el) {
      case "pre": {
        const newpage = currentPage === 1 ? currentPage : currentPage - 1;
        setCurrentPage(()=> newpage);
        document.getElementById("dynamiclist").setAttribute("aria-describedby", `page-${newpage}`);
        break;
      }
      case "next":{
        const newpage = currentPage === lastPage ? currentPage : currentPage + 1;
        setCurrentPage(()=> newpage);
        document.getElementById("dynamiclist").setAttribute("aria-describedby", `page-${newpage}`);
        break;
      }
      default:{
        setCurrentPage(()=>el);
        document.getElementById("dynamiclist").setAttribute("aria-describedby", `page-${el}`);
      }
    }

  }, [currentPage, lastPage]);

  /** - main function
   * We hide the pagination if the dataSurvey is empty - a better way might be needed
   * - we pass pagination component the
   *  1. current page
   *  2. last page
   *  3. callback
   */
  const mainFunction = () => (
    <div>
      <div>
        <AdminTable key='admintable' tableheaders={["Institution", "Org ID", "State", "Zone"]}
        tableBodyrow={[...displaySurvey]} actionDataUpdate={updatePaginationData} totalCount={dataSurvey.length} 
        selectedPageSize={recordPerPage} onSelectPageSize={setRecordPerPage} 
        setCurrentPage={setCurrentPage}/>
      </div>
      <div style={{display: `${dataSurvey.length===0?"none":"inline-block"}`, width: "100%", textAlign: "center"}}>
        <Pagination currentPage={currentPage} lastPage={lastPage} onPageChange={handleOnChange} />
      </div>
    </div>
  );
  // ---REDIRECT WHEN LIVE - happens in order
  //--'false' means we are not live so BLOCK OUR APP
  if(is_BCFP_LIVE==="false" && BCFP_ROLES_ARR.includes(newroles[0])) {
    navigate('/bfcp_is_ready_comingsoon');
  }
  //redirect when you are not admin
  if((newroles[0]!==ADMIN_ROLE)&&(newroles[0]!==EM_ROLE)) {
    navigate('/bfcp-select-organization');
  }
  return(
    <div>
      <div style={{marginBottom: "20px"}}>
        <BandLayout metaData={ADMIN_LANDING_REMINDER} />
      </div>
      {
        !loading?
          <div className='centerEllipsis'><AnimatedEllipsis /></div>:
          mainFunction()
      }
    </div>
  );
}